"use strict";

const TOAST_VISIBLE_CLASS = "is-visible";
const TOAST_HIDING_CLASS = "is-hiding";

function dismissToast(toastEl) {
  if (!toastEl || toastEl.dataset.dismissed === "1") return;

  toastEl.dataset.dismissed = "1";
  const timeoutId = Number(toastEl.dataset.timeoutId || 0);
  if (timeoutId) window.clearTimeout(timeoutId);

  toastEl.classList.remove(TOAST_VISIBLE_CLASS);
  toastEl.classList.add(TOAST_HIDING_CLASS);

  window.setTimeout(() => {
    const container = toastEl.closest("[data-flash-toast-container]");
    toastEl.remove();
    if (container && container.querySelectorAll("[data-flash-toast]").length === 0) {
      container.remove();
    }
  }, 220);
}

function setupToast(toastEl, index) {
  const closeButton = toastEl.querySelector("[data-flash-toast-close]");
  if (closeButton && closeButton.dataset.bound !== "1") {
    closeButton.dataset.bound = "1";
    closeButton.addEventListener("click", () => dismissToast(toastEl));
  }

  window.requestAnimationFrame(() => {
    toastEl.classList.add(TOAST_VISIBLE_CLASS);
  });

  const delay = Number(toastEl.dataset.flashToastDelay || 15000);
  const timeoutId = window.setTimeout(() => {
    dismissToast(toastEl);
  }, delay + index * 120);

  toastEl.dataset.timeoutId = String(timeoutId);
}

function initFlashToasts() {
  const containers = document.querySelectorAll("[data-flash-toast-container]");
  containers.forEach((container) => {
    if (container.dataset.initialized === "1") return;
    container.dataset.initialized = "1";

    const toasts = container.querySelectorAll("[data-flash-toast]");
    toasts.forEach((toastEl, index) => {
      setupToast(toastEl, index);
    });
  });
}

function cleanupToastTimers() {
  document.querySelectorAll("[data-flash-toast]").forEach((toastEl) => {
    const timeoutId = Number(toastEl.dataset.timeoutId || 0);
    if (timeoutId) window.clearTimeout(timeoutId);
  });
}

document.addEventListener("DOMContentLoaded", initFlashToasts);
document.addEventListener("turbo:load", initFlashToasts);
document.addEventListener("turbo:render", initFlashToasts);
document.addEventListener("turbo:before-cache", cleanupToastTimers);
